module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-12"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("CHAPTER VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The Great French Duel—Mistaken Notions—Outbreak in the French Assembly—Calmness of M Gambetta—I Volunteer as Second—Drawing up a Will—The Challenge and its Acceptance—Difficulty in Selection of Weapons—Deciding on Distance—M. Gambetta’s Firmness—Arranging Details—Hiring Hearses—How it was Kept from the Press—March to the Field—The Post of Danger—The Duel—The Result—General Rejoicings—The only One Hurt—A Firm Resolution")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("CHAPTER IX")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("At the Theatre—German Ideal—At the Opera—The Orchestra—Howlings and Wailings—A Curious Play—One Season of Rest—The Wedding Chorus—Germans fond of the Opera—Funerals Needed—A Private Party—What I Overheard—A Gentle Girl—A Contribution—box—Unpleasantly Conspicuous")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("CHAPTER X")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Four Hours with Wagner—A Wonderful Singer, Once—“Only a Shriek”—An Ancient Vocalist—“He Only Cry”—Emotional Germans—A Wise Custom—Late Comers Rebuked—Heard to the Last—No Interruptions Allowed—A Royal Audience—An Eccentric King—Real Rain and More of It—Immense Success—“Encore! Encore!”—Magnanimity of the King")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("CHAPTER XI")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lessons in Art—My Great Picture of Heidelberg Castle—Its Effect in the Exhibition—Mistaken for a Turner—A Studio—Waiting for Orders—A Tramp Decided On—The Start for Heilbronn—Our Walking Dress—“Pleasant march to you”—We Take the Rail—German People on Board—Not Understood—Speak only German and English—Wimpfen—A Funny Tower—Dinner in the Garden—Vigorous Tramping—Ride in a Peasant’s Cart—A Famous Room")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("CHAPTER XII")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The Rathhaus—An Old Robber Knight, Gotz Von Berlichingen—His Famous Deeds—The Square Tower—A Curious old Church—A Gay Turn—out—A Legend—The Wives’ Treasures—A Model Waiter—A Miracle Performed—An Old Town—The Worn Ston")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("CHAPTER XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Early to Bed—Lonesome—Nervous Excitement—The Room We Occupied—Disturbed by a Mouse—Grow Desperate—The Old Remedy—A Shoe Thrown—Result—Hopelessly Awake—An Attempt to Dress—A Cruise in the Dark—Crawling on the Floor—A General Smash-up—Forty-seven Miles’ Travel")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("CHAPTER XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A Famous Turn—out—Raftsmen on the Neckar—The Log Rafts—The Neckar—A Sudden Idea—To Heidelberg on a Raft—Chartering a Raft—Gloomy Feelings and Conversation—Delicious Journeying—View of the Banks—Compared with Railroading")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cf4da25","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TrampAbroad11.vue
// module id = 96
// module chunks = 0